import { TableCell, TableRow } from "@mui/material";

const TableRows = ({title , value}) => {
    return (
        <TableRow>
            <TableCell sx={{fontSize : "12px" , pl : 1 , backgroundColor : "#686868" , color : "white" , width : "32%"}}>
                {title}
            </TableCell>
            <TableCell sx={{fontSize : "12px" }} >
                {value}
            </TableCell>
        </TableRow>
    )
}
export default TableRows;